import Vue from 'vue'
import _ from "underscore";
import { Record } from 'type-r'

import { currentStore as store } from '@models/sitestore'

var ComponentVue = Vue.extend({
    data: function() {
	return {
	    title: '',
	    subtitle: '',	    
            show1: false,
            store: store,
            rules: {
                required: (value:string) => !!value || 'Required.',
                min: (value:string) => value && value.length >= 8 || 'At least 8 characters required'
            }                        
	};
    },
    watch: {
        $route: function(to, from) {
	    this.initFn();
        }    
    },    
    methods: {
	fetch: function(url?:string, data?:any) {
	    url = url || window.location.href;
	    data = data || {};
	    data.vue = 1;
	    $.ajax({
		url:url,
		data,
                cache: false,
		success: (data) => {
		    data = this.procmsg(data);
		    this.fetched(data);
		},
		error: (code, data) => {
		    this.errored(code, data);
		},
		type: 'get'
	    });
	},
	procmsg: function(data:any) {
            var mv = this.store;
            if (data.success && data.success.length) {
                for (var x = 0; x < data.success.length; x++) {
		    mv.success = data.success[x];
                    mv.snackbar = true;
                }
            }
            if (typeof data.error == 'object') {
                for (var k in data.error) {
                    k = k.toString();
                    mv.error = data.error[k];
                    mv.snackbar = true;
                }
            }
            else if (data.error) {
                console.error("procmsg err: ",data);
                mv.error = data.error;
                mv.snackbar = true;
            }

            if (data.info) {
                var info = data.info;
                if (info.url)
                    this.goTo(info.url);
                if (info.title)
                    this.store.title = info.title;
                if (info.subtitle)
                    this.store.subtitle = info.subtitle;
            }
	    return data.data;
        },
        goTo: function(path:string) {
            var url = new URL(path, window.location.href);
            window.location.href = url.href;
        },
        procerr: function(data:any) {
            var mv = this.store;
            if (typeof data == 'string') {
		mv.error = data;
                mv.snackbar = true;
	    }
            else {
                console.error("procerr err: ",data);
                if (data.error && data.error.length) {
                    for (var x = 0; x < data.error.length; x++) {
                        mv.error = data.error[x];
                        mv.snackbar = true;
                    }
                }
            }
        },
	fetched: function(data:any) {
	    for (var k in data) {
		if (this.hasOwnProperty(k)) {
		    if (this[k] instanceof Record)
			this[k].set(data[k], {parse: true});
		    else if (this[k] instanceof Record.Collection) {
			if (typeof data[k] == 'object')
			    this[k].set(Object.values(data[k]), {parse: true});
			else
			    this[k].set(data[k], {parse: true});			    
		    }
		    else {
			this[k] = data[k];
                    }
		}
		else
		    console.error("Didn't assign unenumerated property ", k);
	    }
	},	
	post: function(data?:any, url?:string, cb?:Function, errcb?:Function) {
	    url = url || window.location.href;
	    data = data || {};
	    let ajaxopts:JQuery.AjaxSettings = {
		url:url,
		data:data,
                cache: false,                
		success: (data) => this.posted(this.procmsg(data)),
		error: (code, data) => this.errored(code, data),
		type: 'post',
		method: 'post'
	    };
	    if (data instanceof FormData) {
		ajaxopts.processData = false;
		ajaxopts.contentType = false;
		(ajaxopts.data as FormData).append('vue', '1');
	    }
	    else {
		(ajaxopts.data as any).vue = 1;
	    }
            if (cb) {
                ajaxopts.success = (data) => cb(this.procmsg(data));
            }
            if (errcb) {
                ajaxopts.error = (code, txt) => errcb(this.procmsg(data));
            }
	    $.ajax(ajaxopts);
	},
	posted: function(data:any) {
	    
	},
	cmd: function(url?:string, data?:any, cb?:Function) {
	    if (typeof data == 'function') {
		cb = data;
		data = null;
	    }
	    url = url || window.location.href;

	    data = data || {};
	    data.vue = 1;
	    $.ajax({url:url, cache: false, data, success: (data) => cb ? cb(this.procmsg(data)) : this.cmdfinish(this.procmsg(data)), error: (code, data) => this.errored(code, data), type: 'get'});
	},
	cmdfinish: function(data:any) {
	    
	},	
	errored: function(xhr:XMLHttpRequest, statustxt:string) {
            var mv = this.store;
            mv.error = 'Error: ' + statustxt;
            mv.snackbar = true;
	},
        initFn: function() {
	},	
	afterUpdate: function(cb:Function) {
	    this.$nextTick(() => cb());
	}
    }    
})
export default ComponentVue;
